module.exports = __webpack_public_path__ + "static/media/North-web.efddb4e6.jpg";